export const environment = {
  production: false,
  urlServer: '/api/v1',
  urlBase: '',

  logLevel: 'debug',           // 'trace' | 'debug' | 'info' | 'warn' | 'error' | 'off'
  remoteLogUrl: '',            // deja vacío en local
  appName: 'belockey',
};
